"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider } from "@tanstack/react-query";
import type { QueryClient } from "@tanstack/react-query";
import type { ReactNode } from "react";
interface QueryProviderProps {
  client: QueryClient;
  children: ReactNode;
}

/**
 * Shared QueryClientProvider wrapper.
 *
 * Each app creates its own `QueryClient` via `createQueryClient()` and passes
 * it in, keeping the provider flexible (e.g. web can add ReactQueryDevtools).
 */
export function QueryProvider(t0) {
  const $ = _c(3);
  const {
    client,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== client) {
    t1 = <QueryClientProvider client={client}>{children}</QueryClientProvider>;
    $[0] = children;
    $[1] = client;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}